<template>
    <v-dialog v-model="modalProp" persistent max-width="400">
        <v-card>
            <v-card-title
                class="headline green accent-4 white--text elevation-7"
            >
                Account Validation
            </v-card-title>
            <div style="width:80%; margin:auto" class="">
                <v-card-text class="my-5 text-center subtitle-2">
                    {{
                        resultData
                    }}
                </v-card-text>
            </div>

            <v-card-actions>
                <v-spacer />

                <v-btn
                    color="red darken-1"
                    text
                    @click="(modalProp = false), toLogin()"
                >
                    Proceed Login
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    props: ['yesDialogDoesExist', 'resultData'],
    data: () => ({ showLogin: false }),
    computed: {
        modalProp: {
            get() {
                return this.yesDialogDoesExist
            },
            set(val) {
                this.$emit('pop-yesDialog', val)
            }
        }
    },
    methods: {
        ...mapActions(['toSignupLogin']),
        toLogin() {
            this.toSignupLogin(this.showLogin)
            this.$store.state.accntName = ''
        }
    }
}
</script>

<style></style>
